import { SidebarTrigger } from "@/components/ui/sidebar";
import UserMenu from "@/components/layout/header/user-menu";

export function Header() {
  return (
    <div className="sticky top-0 z-50 flex flex-col">
      <header className="bg-background/50 flex h-14 items-center justify-between gap-3 px-4 backdrop-blur-xl lg:h-[60px] border-b">
        <div className="flex items-center gap-2">
          <SidebarTrigger />
          
        </div>
        
        <div className="flex items-center gap-2">
          <UserMenu />
        </div>
      </header>
    </div>
  );
}
